module.exports = __webpack_public_path__ + "img/quizz-step-4-1.32c4af39.jpg";